import React from 'react';

const InfoRow = ({ icon: Icon, children, className = "" }) => {
  return (
    <div className={`flex items-center gap-2 text-gray-800 text-sm sm:text-base ${className}`}>
      {Icon && <Icon className="text-[#347DFF] flex-shrink-0" />}
      {children}
    </div>
  );
};

export default InfoRow;
